export default "__VITE_ASSET__BWWCUlUI__"